/*global _ */
export const isNil = v => v === undefined || v === null
export const fv = (...args) =>  args.find(v => !isNil(v))
export const getAdminUtils = () => _.get(window.addiesaas, 'utils', {})
